import { TKiosk } from '../../../types/kiosks';
import { LOCALES } from '~/constants/main';
import { BRANCHES_AVAILABILITY_OPTION } from '~/view/screens/BranchesManagementScreen/screens/BranchesScreen/constants/branches';

export const defaultEditableKiosk: TKiosk = {
  id: '',
  branchId: '',
  branchName: '',
  language: LOCALES.EN,
  password: '',
  port: '',
  ip: '',
  terminalId: '',
  isDelete: 0,
  status: 0,
  kiosk_terminal_multiplier: 1,
};

export const KioskMultiplierOptions = [
  { value: 1, label: '1' },
  { value: 100, label: '100' },
];
